
























import { defineComponent, ref, computed } from '@vue/composition-api';
import OareSidebar from './components/base/OareSidebar/index.vue';
import defaultRouter from './router';

export default defineComponent({
  name: 'App',
  components: {
    OareSidebar,
  },
  setup(_, context) {
    const drawer = ref(true);
    const hasLanded = ref(false);

    const sidebarComponent = computed(() => {
      const routeName = context.root.$route.name;
      if (routeName && routeName.includes('dashboard')) {
        return 'OareDashboardSidebar';
      } else if (
        routeName &&
        (routeName.includes('admin') ||
          routeName.includes('manage') ||
          routeName.includes('denylist'))
      ) {
        return 'OareAdminSidebar';
      }
      return 'OareSidebar';
    });

    const router = computed(() => defaultRouter);

    return {
      drawer,
      hasLanded,
      sidebarComponent,
      router,
    };
  },
});
